module.exports = __webpack_public_path__ + "img/dispose.c4dc2c32.svg";